// 专门计算10PX字体各个字符的宽度
// const config = {
//   ',': 2.4,
//   ':': 2.4,
//   '%': 7.8,
//   0: 6.3,
//   1: 4,
//   2: 5.6,
//   3: 5.7,
//   4: 6.3,
//   5: 6,
//   6: 6.4,
//   7: 5.4,
//   8: 6.1,
//   9: 6.4
// }

function isNumber (value) {
  return Object.prototype.toString.call(value) === '[object Number]'
}

export default function caculateWidthBy10FontSize (value, count = 0) {
  let sum = 0
  if (count) {
    sum = count * 6.4
  } else if (isNumber(value)) {
    sum = ((value + '').length * 6.4) + (Math.floor((value ? Math.log10(value) : 0) / 3) * 2.5) + count * 6.4
  } else {
    sum = value.length * 6.4 + count * 6.4
  }
  return Math.ceil(sum)
}
